export const GET_ADMINS_REQUEST = "GET_ADMINS_REQUEST";
export const GET_ADMINS_RESPONSE = "GET_ADMINS_RESPONSE";
export const DELETE_ADMINS_REQUEST = "DELETE_ADMINS_REQUEST";

export const ADD_ADMIN_REQUEST = "ADD_ADMIN_REQUEST";
export const ADD_ADMIN_RESPONSE = "ADD_ADMIN_RESPONSE";

export const EDIT_ADMIN_REQUEST = "EDIT_ADMIN_REQUEST";
export const EDIT_ADMIN_RESPONSE = "EDIT_ADMIN_RESPONSE";
